module.exports = __webpack_public_path__ + "img/ZJ5207.54dc39c1.png";